import React from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import withIntl from "../../../../utils/withIntl";
import ViewOrderItem from "../../ViewOrderItem";
import GetCurrency from "../../../../helper/GetCurrency";

const order = [
  { count: 3, name: "Coffee", unitPrice: 3.35, articlegroupName: "Drinks", articleFirstInArticlegroup: true },
  { count: 1, name: "Tea", unitPrice: 2.55, articlegroupName: "Drinks", articleFirstInArticlegroup: false },
  { count: 2, name: "Hamburger", unitPrice: 8.4, articlegroupName: "Food", articleFirstInArticlegroup: true },
  { count: 1, name: "Fries", unitPrice: 4.4, articlegroupName: "Food", articleFirstInArticlegroup: false },
];

function PrintTakeawayOrderView(props) {
  const layoutOptions = props.layoutOptions;

  const margin = (numberOfLines) => {
    let lines = [];

    for (let i = 0; i < numberOfLines; i++) {
      lines.push(<br />);
    }
    return lines;
  };

  return (
    <div>
      <Typography>{props.intl.formatMessage({ id: "example" })}</Typography>
      <Paper style={{ width: 380, border: "1px solid grey", display: "flex", justifyContent: "center" }}>
        <Grid container style={{ width: 340 }}>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Typography>DELIVERY</Typography>
          </Grid>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Typography>2021-01-07 14:27</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>#3</Typography>
          </Grid>
          <Grid item xs={6} container justify={"flex-end"}>
            <Typography>#3</Typography>
          </Grid>
          <Grid item xs={6} container justify={"flex-end"}>
            <Typography style={{ visibility: "hidden" }}>.</Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography>{props.intl.formatMessage({ id: "delivery_time" })}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>2021-01-07 16:00</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography style={{ visibility: "hidden" }}>.</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>This order has already been paid</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography style={{ visibility: "hidden" }}>.</Typography>
          </Grid>
          {layoutOptions.print_client_details && (
            <>
              <Grid item xs={12}>
                <Typography>Fabio</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>+31889238300</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>Schiedamse Vest 154</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>Rotterdam</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>3011 BH</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography style={{ visibility: "hidden" }}>.</Typography>
              </Grid>
            </>
          )}

          <Grid item xs={12}>
            <hr />
          </Grid>
          {order.map((orderItem) => {
            let articlegroupName = null;

            if (layoutOptions.articlegroup_names_above_articles && orderItem.articleFirstInArticlegroup) {
              articlegroupName = (
                <Grid item xs={12}>
                  {orderItem.articlegroupName}
                </Grid>
              );
            }
            return (
              <>
                {articlegroupName}
                <ViewOrderItem orderItem={orderItem} articleLines={layoutOptions.article.lines} />
              </>
            );
          })}

          <Grid item xs={12}>
            <Typography style={{ visibility: "hidden" }}>.</Typography>
          </Grid>

          {layoutOptions.print_delivery_costs && (
            <>
              <Grid item xs={6}>
                <Typography>{props.intl.formatMessage({ id: "delivery_costs" })}</Typography>
              </Grid>
              <Grid item xs={6} container justify={"flex-end"}>
                <Typography>{GetCurrency()} 2.50</Typography>
              </Grid>
            </>
          )}

          {layoutOptions.print_payment_costs && (
            <>
              <Grid item xs={6}>
                <Typography>{props.intl.formatMessage({ id: "payment_costs" })}</Typography>
              </Grid>
              <Grid item xs={6} container justify={"flex-end"}>
                <Typography>{GetCurrency()} 0.50</Typography>
              </Grid>
            </>
          )}

          {layoutOptions.print_total && (
            <>
              <Grid item xs={6}>
                <Typography>{props.intl.formatMessage({ id: "subtotal" })}</Typography>
              </Grid>
              <Grid item xs={6} container justify={"flex-end"}>
                <Typography>
                  {GetCurrency()}{" "}
                  {order
                    .reduce((subtotal, orderItem) => {
                      return subtotal + orderItem.unitPrice * orderItem.count;
                    }, 0)
                    .toFixed(2)}
                </Typography>
              </Grid>
            </>
          )}
        </Grid>
      </Paper>
    </div>
  );
}

export default withIntl(PrintTakeawayOrderView);
